/* eslint-disable react/jsx-props-no-spreading */
import React, { FC, useState } from 'react';
import { Approval } from 'api/approval';
import { ApprovalsPaneContext } from 'contexts/approvals-pane';
import { Document as DocumentBase } from './document';
import { DocumentProvider } from './document-store';
import { Props } from './document.types';

export const Document: FC<Props> = (props) => {
  const [newApprovalData, setNewApprovalData] =
    useState<Partial<Approval> | undefined>();

  return (
    <DocumentProvider>
      <ApprovalsPaneContext.Provider
        value={{ newApprovalData, setNewApprovalData }}
      >
        <DocumentBase {...props} />
      </ApprovalsPaneContext.Provider>
    </DocumentProvider>
  );
};
